export default {
  subTitle: 'Settings',
  pageTitle: 'Signage screens',
  description: "Here, you can create and edit a message which is used on your signage screens at the location. ",

  changeMessageButton: 'Change message',
  chnageMessageLoadingButton: 'Changing message...',
  changeMessageSuccessToast: 'The message is created'
}